import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { SeriesBadgeProps } from "./SeriesBadge.types"

const icon = faIcon({ name: "layer-group", style: "regular" })

export default function SeriesBadge(props: SeriesBadgeProps) {
    const { seriesId, size = "md" } = props

    // e.g. "Belongs to series\nJS-10001".
    const tooltip = `Belongs to series\n${seriesId}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            Series
        </Badge>
    )
}
